import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthState } from '../../utils/authUtils'

const CheckAuth = () => {
  const { reloadUserErr } = useAuthState()
  const navigate = useNavigate()

  useEffect(() => {
    const initAuth = async () => {
      try {
        await reloadUserErr() // 사용자 및 봇 상태 업데이트
      } catch (error) {
        navigate('/signIn') // 인증 실패 시 홈으로 이동
      }
    }

    initAuth()
  }, [])

  return null
}

export default CheckAuth
